import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    height: "40px",
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.background.white,
    },
    "& .MuiGrid-root.MuiGrid-item": {
      margin: 0,
    },
  },
  container: {
    padding: 0,
    margin: 0,
  },
  select: {
    padding: theme.spacing(2),
  },
  input: {
    padding: 0,
  },
  dropdown: {
    ".MuiOutlinedInput-notchedOutline": {
      borderColor: "pink !important",
    },
    ".Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "green !important",
    },
  },
  buttonPrimary: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    width: "100%",
    marginRight: 15,
    fontWeight: 400,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  buttonSecondary: {
    color: theme.palette.Primary.background,
    borderColor: theme.palette.Primary.background,
    background: theme.palette.background.white,
    textTransform: "capitalize",
    width: "100%",
    "&:hover": {
      borderColor: theme.palette.Primary.background,
      backgroundColor: theme.palette.Secondary.hoverButton,
    },
    marginRight: theme.spacing(5),
  },
  card: {
    background: "white",
    padding: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 8,
    width: "100%",
    boxSizing: "border-box",
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), -4px 0px 4px rgba(0, 0, 0, 0.05)",
    marginBottom: theme.spacing(2),
  },
  filterText: {
    whiteSpace: "nowrap",
    fontWeight: 500,
    paddingRight: theme.spacing(3),
  },
  multiSelect: {
    minWidth: 160,
    width: "auto",
    // width: "165px !important",
    margin: theme.spacing(0, 1),
    height: 33,
    borderColor: "#D1BDC8 !important",
    borderRadius: 8,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D1BDC8 !important",
      borderRadius: 8,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D1BDC8 !important",
      borderRadius: 8,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D1BDC8 !important",
      borderRadius: 8,
    },
  },
  labels: {
    position: "relative",
    paddingLeft: "12px",
    display: "flex",
    background: "white",
    marginRight: 2,
    alignItems: "center",
    letterSpacing: 0,
    "justCheckSelected-66 > fieldset > legend": {
      display: "none !important",
    },
    whiteSpace: "nowrap",
    minWidth: "0",
    gap: "6px", // ✅ for spacing between icon and text
    flexWrap: "nowrap",
  },
  labelText: {
    position: "relative",
    color: "black",
    fontSize: 14,
    letterSpacing: 0,
    fontWeight: 400,
    flexShrink: 0, // ✅ don’t let it shrink
    minWidth: "fit-content", // ✅ allow full word (e.g., "Country") to show
    maxWidth: "100%",
  },
  justCheckSelected: {
    "& > fieldset > legend": {
      display: "none !important",
    },
  },
  label: {
    margin: "-10px !important",
    "&. MuiFormLabel-filled": {
      margin: "-10 !important",
    },
  },
  tabsContainer: {},
  tabs: {
    zIndex: 1,
    position: "relative",
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.login.loginButton,
      display: "none",
    },
    borderRadius: 10,

    "& .MuiTabs-flexContainer": {
      margin: "auto",
      display: "flex",
      zIndex: 2,
      borderRadius: 5,
    },
    "& .MuiTab-root.Mui-selected": {
      color: `${theme.palette.login.loginButton} !important`,
    },
  },
  tabOption: {
    textTransform: "capitalize",
    // fontSize: 10,
  },
  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  tabTitle: {
    marginLeft: 8,
    marginRight: 6,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
  },

  backContainer: {
    color: theme.palette.Primary.background,
    textTransform: "capitalize",
    display: "flex",
    paddingBottom: 10,
    paddingTop: 10,
    paddingLeft: 20,
    alignItems: "center",
    cursor: "pointer",
  },
  buttonPrimaryConfig: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    padding: "6px 16px",
    fontSize: "14px",
    minHeight: "40px",
    minWidth: "160px",
    marginRight: 15,
    fontWeight: 400,
    marginBottom: "7px",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },

  adjustedHead: {
    display: "flex",
    width: "100%",
    "& .MuiGrid-root > .MuiFormControl-root": {
      width: "100%",
    },
    "& .MuiGrid-root >.MuiButtonBase-root": {
      // width: "50%",
    },
  },
  headClass: {
    display: "flex",
    width: "100%",
  },

  unifiedFilterRow: {
    width: "100%",
    padding: "12px 24px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.default,
  },

  filterRow: {
    width: "100%",
    minWidth: 0,
  },

  filterControls: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    flex: "1 1 auto",
    minWidth: 0,
  },

  filterItem: {
    flex: "1 1 260px",
    minWidth: 240,
    maxWidth: "100%",
  },

  multiSelectNarrow: {
    width: "200px !important",
    minWidth: 160,
    maxWidth: 240,
  },

  filterTextTight: {
    paddingRight: theme.spacing(1),
  },

  filterRowWhenDrawer: {
    gap: theme.spacing(1.5),
    [theme.breakpoints.up("lg")]: {},
  },

  filterTextCompact: {
    paddingRight: theme.spacing(1),
  },

  gridItemCompact: {
    flexBasis: "auto !important",
    maxWidth: "none !important",
    width: "auto !important",
    flexShrink: 1,
  },

  labelTextCompact: {
    fontSize: 13.5,
    flexShrink: 1,
    minWidth: 0,
    maxWidth: 120,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  filterRowDense: { gap: theme.spacing(1) },
  labelsCompact: {
    gap: "4px",
    "& img": { height: 14, width: 14 },
  },
  multiSelectCompact: {
    width: "50px !important",
    minWidth: 160,
    maxWidth: 240,
    "& .MuiOutlinedInput-root": { height: 34 },
    "& .MuiInputBase-input": { padding: "6px 10px" },
    "& .MuiSelect-icon": { fontSize: "1rem" },
  },
}));

export default useStyles;
